import React from 'react';
import { useState, useEffect } from 'react';
import { FaStar, FaHeart, FaShoppingCart, FaHome } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import ProductCard from '../components/ProductCard';

function Home() {
  const [displayedText, setDisplayedText] = useState('');
  const fullText = 'Καλώς ήλθατε στο Ferupen';
  
  useEffect(() => {
    let index = 0;
    const timer = setInterval(() => {
      if (index <= fullText.length) {
        setDisplayedText(fullText.slice(0, index));
        index++;
      } else {
        clearInterval(timer);
      }
    }, 100);
    
    return () => clearInterval(timer);
  }, []);

  const products = [
    {
      id: 1,
      name: 'Κλασική Κρέμα Ξυρίσματος Premium',
      shortDescription: 'Πλούσια κρέμα ξυρίσματος με φυσικά συστατικά για απαλό δέρμα',
      price: 45.99,
      image: '/images/1.jpg'
    },
    {
      id: 2,
      name: 'Έλαιο Περιποίησης Μούσι Deluxe',
      shortDescription: 'Θρεπτικό έλαιο για υγιές και λαμπερό μούσι',
      price: 38.50,
      image: '/images/2.jpg'
    },
    {
      id: 3,
      name: 'Κερί Μαλλιών Ματ Φινίρισμα',
      shortDescription: 'Επαγγελματικό κερί για τέλειο στυλ που διαρκεί',
      price: 32.00,
      image: '/images/3.jpg'
    },
    {
      id: 4,
      name: 'Αφρόλουτρο Gentleman Sandalwood',
      shortDescription: 'Αρωματικό αφρόλουτρο με ξύλο σανταλιού',
      price: 28.75,
      image: '/images/4.jpg'
    },
    {
      id: 5,
      name: 'Σετ Περιποίησης Barbershop Essentials',
      shortDescription: 'Πλήρες σετ περιποίησης για τον σύγχρονο κύριο',
      price: 89.99,
      image: '/images/5.jpg'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Ferupen - Premium Barbershop & Grooming Products</title>
        <meta name="description" content="Ανακαλύψτε premium προϊόντα περιποίησης για άνδρες στο Ferupen Barbershop. Κρέμες ξυρίσματος, έλαια μούσι και περισσότερα." />
        <meta property="og:title" content="Ferupen - Premium Barbershop" />
        <meta property="og:description" content="Τα καλύτερα προϊόντα περιποίησης για άνδρες" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            "itemListElement": products.map((product, index) => ({
              "@type": "ListItem",
              "position": index + 1,
              "item": {
                "@type": "Product",
                "name": product.name,
                "description": product.shortDescription,
                "image": `https://ferupen.com${product.image}`,
                "offers": {
                  "@type": "Offer",
                  "price": product.price,
                  "priceCurrency": "EUR"
                }
              }
            }))
          })}
        </script>
      </Helmet>

      <div className="hero-section">
        <div className="hero-content">
          <h2 className="typewriter-text">{displayedText}</h2>
          <p>
            Εμπειρία premium περιποίησης για τον σύγχρονο κύριο. 
            Ανακαλύψτε την κομψότητα του παραδοσιακού κουρειο κουρείου με σύγχρονα προϊόντα υψηλής ποιότητας.
          </p>
          <div className="language-switcher">
          </div>
        </div>
      </div>

      <section className="features-section">
        <h2>Γιατί να επιλέξετε το Ferupen</h2>
        <p className="features-subtitle">
          Η τέλεια επιλογή για κάθε κύριο που αναζητά την κορυφαία ποιότητα
        </p>

        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon"><FaStar /></div>
            <h3>Premium Ποιότητα</h3>
            <p>
              Όλα τα προϊόντα μας κουρείο κοντά μου επιλέγονται προσεκτικά για να εξασφαλίσουν 
              την υψηλότερη ποιότητα και αποτελεσματικότητα. Μόνο τα καλύτερα 
              για τους πελάτες μας.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon"><FaHeart /></div>
            <h3>Φυσικά Συστατικά</h3>
            <p>
              Χρησιμοποιούμε αποκλειστικά φυσικά και οργανικά συστατικά που 
              σέβονται το δέρμα σας και το περιβάλλον. Χωρίς κουρεια κοντα μου επιβλαβείς χημικές ουσίες.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon"><FaShoppingCart /></div>
            <h3>Εύκολη Αγορά</h3>
            <p>
              Απλή και ασφαλής διαδικασία παραγγελίας με γρήγορη παράδοση. 
              Το online κατάστημά μας είναι διαθέσιμο όλο το εικοσιτετράωρο.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon"><FaHome /></div>
            <h3>Παράδοση στο Σπίτι</h3>
            <p>
              Παραλάβετε music barber shop κουρείο τα premium προϊόντα σας άνετα στο χώρο σας με 
              γρήγορη και ασφαλή παράδοση σε όλη την Ελλάδα.
            </p>
          </div>
        </div>

        <div className="stats-container">
          <div className="stat-item">
            <span className="stat-number">10,000+</span>
            <span className="stat-label">Ευχαριστημένοι Πελάτες</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">15+</span>
            <span className="stat-label">Χρόνια Εμπειρίας</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">100%</span>
            <span className="stat-label">Φυσικά Προϊόντα</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">50+</span>
            <span className="stat-label">Premium Προϊόντα</span>
          </div>
        </div>

        <div style={{ textAlign: 'center' }}>
          <a href="#products" className="cta-button">
            Εξερευνήστε τα Προϊόντα μας
          </a>
        </div>
      </section>

      <section className="about-products-section">
        <h2>Η Φιλοσοφία μας</h2>
        <div className="about-products-content">
          <p>
            Στο Ferupen Barbershop, πιστεύουμε το κουρειο τησ γειτονιασ ότι η περιποίηση είναι μια τέχνη που 
            απαιτεί τα καλύτερα εργαλεία και προϊόντα. Η συλλογή μας έχει επιμεληθεί 
            με απόλυτη προσοχή στη λεπτομέρεια, συνδυάζοντας παραδοσιακές τεχνικές 
            barbering με σύγχρονες καινοτομίες στην περιποίηση.
          </p>

          <p>
            Κάθε προϊόν στο κατάλογό μας επιλέγεται με αυστηρά κριτήρια ποιότητας. 
            Συνεργαζόμαστε με κορυφαίους κατασκευαστές από όλο τον κόσμο που μοιράζονται 
            το όραμά μας για excellence. Από κλασικές κρέμες ξυρίσματος μέχρι σύγχρονα 
            styling products, κάθε είδος έχει δοκιμαστεί και εγκριθεί από επαγγελματίες 
            του χώρου.
          </p>

          <h3>Φυσικά και Οργανικά Συστατικά</h3>
          <p>
            Η υγεία του δέρματος και των μαλλιών σας είναι προτεραιότητά μας. Γι αυτό 
            επιλέγουμε προϊόντα που περιέχουν φυσικά και οργανικά συστατικά, χωρίς 
            επιβλαβείς χημικές ουσίες, parabens ή τεχνητά χρώματα. Κάθε φόρμουλα είναι 
            σχεδιασμένη να θρέψει, να προστατεύσει και να ενισχύσει τη φυσική ομορφιά σας.
          </p>

          <h3>Κληρονομιά και Παράδοση</h3>
          <p>
            Το Ferupen ξεκίνησε το 2010 με ένα απλό όραμα: να φέρει την κλασική εμπειρία 
            του barbershop στο σπίτι του σύγχρονου κυρίου. Εμπνευσμένοι από τα κλασικά 
            gentleman clubs και τα παραδοσιακά κουρεία, περιποίηση μαλλιών δημιουργήσαμε μια συλλογή που 
            συνδυάζει την κομψότητα του παρελθόντος με την αποτελεσματικότητα του σήμερα.
          </p>

          <h3>Εγγύηση Ποιότητας</h3>
          <p>
            Κάθε προϊόν συνοδεύεται από την εγγύησή μας για απόλυτη ικανοποίηση. Είμαστε 
            τόσο σίγουροι για την ποιότητα των προϊόντων μας που προσφέρουμε πλήρη εγγύηση 
            επιστροφής χρημάτων εάν δεν μείνετε απόλυτα ευχαριστημένοι. Η αριστεία δεν 
            είναι απλώς στόχος μας, είναι η υπόσχεσή μας.
          </p>
        </div>
      </section>

      <section className="products-section" id="products">
        <h2>Τα Premium Προϊόντα μας</h2>
        <div className="products-grid">
          {products.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </section>
    </>
  );
}

export default Home;